// import { Container } from './styles';

import { Typography } from "@material-ui/core";
import { Link } from "react-router-dom";
import BottomBar from "../../components/BottomBar";
import PageContainer from "../../components/PageContainer";
import TopBar from "../../components/TopBar";
import { useStyles } from "./styles";

function NotFound() {
  const classes = useStyles();
  return(
    <>
      <TopBar>
        <Typography variant="h1">
          Página não encontrada!
        </Typography>
      </TopBar>
      <PageContainer>
        <div className={classes.wrapper}>
          <Typography>
            Ops... Esta página não foi encontrada!
          </Typography>
          <Typography>
            <Link to="/">Clique aqui</Link> para ir a página principal.
          </Typography>
        </div>
      </PageContainer>
      <BottomBar/>
    </>
  )
}

export default NotFound;